const NAMED: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
  ndash: '–',
  mdash: '—',
  hellip: '…',
  lsquo: '‘',
  rsquo: '’',
  ldquo: '“',
  rdquo: '”',
  bull: '•',
  middot: '·',
  copy: '©',
  reg: '®',
  trade: '™',
  deg: '°',
  times: '×',
};

const ENTITY = /&(#x[0-9a-f]+|#\d+|[a-z]+);/gi;

function decodeOnce(value: string): string {
  return value.replace(ENTITY, (match, body: string) => {
    if (body[0] === '#') {
      const code = body[1] === 'x' || body[1] === 'X'
        ? Number.parseInt(body.slice(2), 16)
        : Number.parseInt(body.slice(1), 10);
      return Number.isFinite(code) && code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : match;
    }
    return NAMED[body.toLowerCase()] ?? match;
  });
}

/**
 * Text scraped from websites and echoed by the model can arrive
 * HTML-escaped ("LC Heating &amp; Air", "Joe&#39;s"). React renders strings
 * literally, so anything shown to the rep goes through this first. Decodes
 * twice to undo a double escape ("&amp;amp;"); unknown entities stay as typed.
 */
export function decodeEntities(value: string): string {
  if (!value.includes('&')) return value;
  return decodeOnce(decodeOnce(value));
}
